import { Layout } from 'components/widgets';
import { Saved } from 'components/containers';
import { ActiveSavedAlerts } from 'components/widgets';
import { usePathIndicator } from 'hooks';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ALERT_MIXED_TYPES, LINKS } from 'utils/constants';

export default function EditSavedAlertPage() {
  const { id } = useParams();
  const alert = useSelector((state) =>
    state.notifications[ALERT_MIXED_TYPES.saved].results.find(
      (a) => a.id === id
    )
  );

  usePathIndicator([LINKS.saved, LINKS.savedAll, LINKS.savedEdit]);
  // useAsyncAction(getSavedAlerts(), isEmpty(alert));

  return (
    <Layout sidebar={<ActiveSavedAlerts />}>
      {alert && <Saved defaultValues={alert} key={id} updating />}
    </Layout>
  );
}
